export const ouiMessages = {
  en: {
    actionsColumn: 'Actions',
    btnAdd: 'Add OUI',
    btnClearSettings: 'Reset to Factory Settings',
    ouiResetSuccess: 'OUI settings reset',
    resetSettingsConfirmDialog: {
      header: 'Reset OUI to factory settings',
      subHeader: 'Do you really want to reset to factory settings?',
      btnConfirm: 'Reset',
      btnSecondaryConfirm: 'Cancel',
    },
    form: {
      oui: 'OUI',
      vendor: 'Vendor',
      enabled: 'Enabled for discovery',
      btnAdd: 'Add OUI',
      btnUpdate: 'Update OUI',
      addTitle: 'Add OUI',
      editTitle: 'Edit OUI {name}',
      validations: {
        required: 'Required',
        ouiLength: 'OUI must have 6 characters',
      },
      saveSuccess: 'OUI saved',
      updateSuccess: 'OUI updated',
      resourceConflict: "Can't save, this OUI is already stored in DB",
    },
    // UNUSED
    columns: {
      enabled: { name: 'Enabled for discovery', help: '' },
      vendor: { name: 'Vendor', help: '' },
      oui: { name: 'OUI', help: '' },
      actions: { name: 'Actions', help: '' },
    },
    yes: 'Yes',
    no: 'No',
    btnEdit: 'Edit',
    btnEnable: 'Enable',
    btnDisable: 'Disable',

    request: {
      saveSuccess: 'OUI saved',
      updateSuccess: 'OUI updated',
      resourceConflict: "Can't save, this OUI is already stored in DB",
      ouiResetSuccess: 'OUI settings reset',
    },
  },
};
